import { SxProps } from '@mui/material';

export const ModalOutfitsContainerInner: SxProps = {
	backgroundColor: { xs: 'white', md: 'white' },
	maxWidth: '886px !important',
	maxHeight: { xs: '100dvh', md: '80vh !important' },
	padding: { xs: '0px 0px', md: '0px 40px 40px 40px' },
	display: 'flex',
	flexDirection: 'column',
	gap: { xs: '10px', md: '0px' },
};
